export class TrackerUserModel {
	uid: number;
	name: string;
	is_active?: boolean;
}
